/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from "@angular/core";
import { IAddFittingTabFacade } from "@hcworkspace/sysque/toolbelt/data-access";
import { Store } from "@ngrx/store";
import { InitializeRootPath } from "../toolbelt.actions";
import { GetTreeViewRootDirectory } from "../fitting-tree-view/fitting-tree-view-actions";
import { BehaviorSubject } from "rxjs";
import { LocalStorageService } from "../../../../../../toolbelt/utils/src/lib/local-storage/local-storage.service";

@Injectable({ providedIn: 'root' })
export class AddFittingTabFacade implements IAddFittingTabFacade {

    constructor(public store: Store, public localStorageService: LocalStorageService) { }

    notifySelectorChange: BehaviorSubject<string> = new BehaviorSubject<string>('curateSearch');
    getTreeViewRootDirectory() {
        this.store.dispatch(GetTreeViewRootDirectory());
    }

    initializeRootPath() {
        this.store.dispatch(InitializeRootPath());
    }
    getLocalStorageUpdate() {
        return this.localStorageService.localStorageUpdate$
    }

}